import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useMemo } from 'react';
import { exportQueryKeys } from './exportQueryKeys.js';
import { useWoody } from '../../woody/woody.js';
import { ResourceExportLogStatus } from '@fabric/woody-client';

const useQueryExportRequests = (filter) => {
  const { client } = useWoody();
  const query = {
    /**
    * @TODO pagination
    * currently not necessary as we don't have a view for exports
    * currently only cosumer is useQueryUnfinishedEntireAppExportRequests
    * where count should in theory not exceed 1
    */
    limit: 50,
    offset: 0,
    ...filter
  };
  return useQuery({
    queryKey: exportQueryKeys.exportRequests(query),
    queryFn: async () => {
      const res = await client.v2("/v2/export", {
        method: "get",
        query
      });
      return res;
    },
    retry: 0,
    placeholderData: keepPreviousData
  });
};
const useQueryUnfinishedEntireAppExportRequests = () => {
  const filter = {
    status: [
      ResourceExportLogStatus.PENDING,
      ResourceExportLogStatus.IN_PROGRESS
    ],
    entireAppExport: true
  };
  return useQueryExportRequests(filter);
};
const useIsUnfinishedRequestByResourceId = (resourceId) => {
  const query = useQueryExportRequests({
    status: [
      ResourceExportLogStatus.PENDING,
      ResourceExportLogStatus.IN_PROGRESS
    ],
    limit: 50
  });
  return useMemo(() => query.data?.data.exportLogRequests?.find((request) => request.resourceIds.length === 1 && request.resourceIds.includes(resourceId)) ? true : false, [
    query.data?.data.exportLogRequests,
    resourceId
  ]);
};

export { useIsUnfinishedRequestByResourceId, useQueryUnfinishedEntireAppExportRequests };
//# sourceMappingURL=useQueryExportRequests.js.map
